import src from "./drag-race-chat-screenshot.png"

const width = 720
const height = 1367
export default { src, width, height }
